"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMachines = getMachines;
async function getMachines(advertisingRepo) {
    return advertisingRepo.getMachines();
}
